export enum CommunityFormSteps {
  MainInfo = 'mainInfo',
  AccessSettings = 'accessSettings',
  Address = 'address',
}
